import { httpRequest } from '@/utils/request';
import { CommonResponse } from '@/types';

export interface DeviceGroupType {
  id: string;
  name: string;
  parent_id?: string;
  sort?: number;
  children?: DeviceGroupType[];
}

/** 获取分组（树） GET /api/v1/device-group */
export function getDeviceGroup() {
  return httpRequest<any, CommonResponse<DeviceGroupType[]>>({
    url: '/api/v1/device-group',
    method: 'get',
  });
}

/** 添加分组 POST /api/v1/device-group */
export function addDeviceGroup(data: {
  name: string;
  parent_id?: string;
  sort?: number;
}) {
  return httpRequest<any, CommonResponse<DeviceGroupType>>({
    url: '/api/v1/device-group',
    method: 'post',
    data,
  });
}

/** 更新分组 PUT /api/v1/device-group */
export function updateDeviceGroup(data: {
  id: string;
  name: string;
  parent_id?: string;
  sort?: number;
}) {
  return httpRequest<any, CommonResponse<DeviceGroupType>>({
    url: '/api/v1/device-group',
    method: 'put',
    data,
  });
}

/** 删除分组 DELETE /api/v1/device-group/{deviceGroupId} */
export function deleteDeviceGroup(deviceGroupId: string) {
  return httpRequest<any, CommonResponse<any>>({
    url: `/api/v1/device-group/${deviceGroupId}`,
    method: 'delete',
  });
}

/** 获取分组下所有设备信息（分页） GET /api/v1/device-group/devices */
export function getDeviceGroupDevices(params: {
  device_group_id?: string;
  page: number;
  pageSize: number;
  name?: string;
  product_id?: string;
}) {
  // 如果 device_group_id 为空，不传递该参数
  const requestParams: any = {
    page: params.page,
    pageSize: params.pageSize,
  };
  if (params.device_group_id) {
    requestParams.device_group_id = params.device_group_id;
  }
  if (params.name) {
    requestParams.name = params.name;
  }
  if (params.product_id) {
    requestParams.product_id = params.product_id;
  }
  return httpRequest<any, CommonResponse<{ list: any[]; total: number; page: number; pageSize: number }>>({
    url: '/api/v1/device-group/devices',
    method: 'get',
    params: requestParams,
  });
}

/** 绑定设备 POST /api/v1/device-group/bind-device */
export function bindDeviceGroupDevice(data: {
  device_group_id: string;
  device_ids: string[];
}) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/device-group/bind-device',
    method: 'post',
    data,
  });
}

/** 解绑设备 POST /api/v1/device-group/unbind-device */
export function unbindDeviceGroupDevice(data: {
  device_group_id: string;
  device_ids: string[];
}) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/device-group/unbind-device',
    method: 'post',
    data,
  });
}

/** 设备分组排序 PUT /api/v1/device-group/sort */
export function sortDeviceGroup(data: {
  id: string;
  sort: number;
  parent_id?: string;
}) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/device-group/sort',
    method: 'put',
    data,
  });
}


